<template>
  <div class="card">
    <div>
      <p>{{ title }}</p>
      <span class="value">{{ value }}</span>
      <slot />
    </div>
    <img
      :src="icon"
      width="62"
      height="62"
    >
  </div>
</template>

<script>
export default {
    name: "Card",
    props: [
        'title',
        'value',
        'icon'
    ]
}
</script>

<style scoped lang="scss">
.card {
    width: 100%;
    height: 84px;
    background: #FFFFFF;
    box-shadow: 0px 0px 0px 1px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15);
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    padding: 11px 20px;

    div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        p {
            text-transform: uppercase;
            font-size: 12px;
            color: #66788A;
            font-weight: 700;
        }

        .value {
            font-size: 28px;
            font-weight: 500;
            color: #212529;
        }
    }
}
</style>